import { ContentLoader } from 'vue-content-loader' ;
import { Component } from 'vue-property-decorator' ;
import LoaderPalette from '../../../../components/loader-palette';

interface MessageBox {
    height: number;
    width: number;
    radius: number
}

@Component({
    components: {
        ContentLoader
    }
})
class TicketChatContent extends LoaderPalette {

    readonly dtBigMessageBox: MessageBox;
    readonly dtSmallMessageBox: MessageBox;

    constructor(){
        super()

        this.dtBigMessageBox= {
            height: 80,
            width: 150,
            radius: 7
        }

        this.dtSmallMessageBox= {
            height: 30,
            width: 40,
            radius: 4
        }
    }
}

export default TicketChatContent


// WEBPACK FOOTER //
// ./src/containers/ticket/loaders/ticket-chat-content-loader/index.ts